var SiteService = function() {
  this.addSponsorClass = function(){
   
  };
};

module.exports = new SiteService();